var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4106_27558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1185 18.2988L16.2476 3.32223C15.5312 1.95909 14.1295 1.1123 12.5896 1.1123C11.0496 1.1123 9.64803 1.95909 8.93155 3.32223L1.06077 18.2988C0.391662 19.572 0.438065 21.1274 1.18171 22.3577C1.92519 23.5887 3.28055 24.3535 4.71879 24.3535H20.4605C21.8985 24.3535 23.2539 23.5888 23.9974 22.3581C24.7411 21.1274 24.7875 19.572 24.1185 18.2988ZM21.9395 21.1147C21.6285 21.6296 21.0617 21.9493 20.4604 21.9493H4.71871C4.11724 21.9493 3.55055 21.6296 3.23952 21.1145C2.92857 20.6 2.90926 19.9497 3.18903 19.4173L11.0599 4.44062C11.3594 3.87065 11.9456 3.5165 12.5896 3.5165C13.2335 3.5165 13.8198 3.87057 14.1193 4.44062L21.9901 19.4173C22.2699 19.9497 22.2506 20.6 21.9395 21.1147Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1334 16.8757H13.0464L13.9372 7.72852H11.2424L12.1334 16.8757Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5893 17.7246C11.8696 17.7246 11.2869 18.3074 11.2869 19.0271C11.2869 19.746 11.8696 20.3295 12.5893 20.3295C13.3089 20.3295 13.8917 19.746 13.8917 19.0271C13.8917 18.3075 13.3089 17.7246 12.5893 17.7246Z",
    fill: "#17B67C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4106_27558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.589844 0.732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWarning);
export default __webpack_public_path__ + "static/media/greenWarning.d2451f5e154d8cdf1058f950cfd42eae.svg";
export { ForwardRef as ReactComponent };